<template>
  <b-card title="Doughnut">
    <b-card img-bottom>
      <ChartDoughnutBase :chart-data="chartData" />
    </b-card>
  </b-card>
</template>

<script>
import ChartDoughnutBase from "./ChartDoughnutBase.js";

export default {
  components: {
    ChartDoughnutBase
  },
  data() {
    return {
      chartData: null
    };
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.chartData = {
        datasets: [
          {
            backgroundColor: ["#185190","#f36e60", "#ffdb3b" ],
            hoverBackgroundColor: ["#d1e3f7","#fbd2cd", "#fef5c9"],
            data: [55, 35, 10]
          }
        ],
        labels: ["Product A(55%)", "Product B(35%)", "Product C(10%)"]
      };
    }
  }
};
</script>
